<template>
  <div>
    <v-card class="rounded-lg">
      <v-card-text>
        <v-layout row wrap justify-center align-center pb-3>
          <v-flex xs12 lg12 pa-2>
            <div v-if="file == ''">
              <div
                :class="['dropZone', dragging ? 'dropZone-over' : '']"
                @dragenter="dragging = true"
                @dragleave="dragging = false"
              >
                <div class="dropZone-info" @drag="Fn_OnChange">
                  <span class="dropZone-title">
                    <h3>
                      <v-icon size="38" color="#077893"
                        >mdi-inbox-arrow-down-outline</v-icon
                      >
                    </h3>
                  </span>
                  <div class="dropZone-upload-limit-info">
                    <div>
                      {{ $t("oneAccount.text3") }}
                    </div>
                    <div>{{ $t("oneAccount.text4") }}</div>
                    <div class="red--text pt-4">
                      <b> ***</b> {{ $t("oneAccount.Note") }}
                    </div>
                  </div>
                </div>
                <input
                  accept=".xls,.xlsx"
                  multiple
                  type="file"
                  @change="Fn_OnChange"
                />
              </div>
            </div>
            <v-card outlined v-else>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#077893"
                  :loading="LoadingUpload"
                  dark
                  @click="Fn_SubmitFile"
                  ><v-icon class="mr-1">mdi-tray-arrow-up</v-icon>
                  อัปโหลด</v-btn
                >
                <v-btn color="error" @click="Fn_RemoveFile">
                  <v-icon>mdi-trash-can-outline</v-icon> เคลียร์ข้อมูล</v-btn
                >
              </v-card-actions>
              <v-card-text>
                <center>
                  <img
                    height="100"
                    width="100"
                    :src="require('@/assets/img/excel.png')"
                  />
                  <p>{{ file.name }}</p>
                </center>
                <v-layout row wrap justify-center align-center>
                  <v-flex v-if="showeProgress" lg12 sm12 md12 class="text-end">
                    <span class="blue--text"
                      ><b>{{ value }} %</b></span
                    >
                  </v-flex>
                </v-layout>
                <div style="min-height: 4px">
                  <v-progress-linear
                    v-if="showeProgress"
                    v-model="value"
                    color="#077893"
                    :active="show"
                    :indeterminate="query"
                    :query="true"
                    class="mt-2"
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-stepper
          v-model="StatusBtn"
          class="rounded-lg elevation-0 ma-2"
          outlined
        >
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card-text class="pa-0">
                <v-layout row wrap justify-start align-center pl-4 mt-n6>
                  <v-flex xs4 sm4 md2 lg2>
                    <v-select
                      v-model="ItemPerPage"
                      dense
                      outlined
                      hide-details
                      rounded
                      color=""
                      :items="ListPerpage"
                      class="text-subtitle-2"
                      prepend-icon="mdi-clipboard-list"
                      append-icon="mdi-arrow-up-down"
                      @input="Fn_SelectPerPage()"
                    />
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs4 lg4 ma-2 pt-6>
                    <v-text-field
                      rounded
                      outlined
                      dense
                      v-model="Search"
                      :label="$t('consentlist.search')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-data-table
                  :loading="btnSendLoading"
                  v-model="SelectNameEmployee"
                  :headers="headers"
                  :items="ItemEmployee"
                  item-key="AccountId"
                  :search="Search"
                  show-select
                  class="elevation-0"
                  :loading-text="$t('overlay.load')"
                  hide-default-footer
                  :items-per-page="ItemPerPage"
                >
                  <template v-slot:[`item.NameTh`]="{ item }">
                    <div v-if="$t('default') === 'th'">
                      {{ item.NameTh }}
                    </div>
                    <div v-else>
                      {{ item.NameEng }}
                    </div>
                  </template>
                  <template v-slot:[`item.UpdatdeAt`]="{ item }">
                    <div v-if="$t('default') === 'th'">
                      {{ item.UpdatdeAt }}
                    </div>
                    <div v-else>
                      {{ item.UpdatdeAtEng }}
                    </div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          dark
                          v-bind="attrs"
                          v-on="on"
                          small
                          class="mx-2"
                          fab
                          color="#077893"
                        >
                          <v-icon dark size="20">
                            mdi-format-list-bulleted-square
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list v-for="(list, i) in itemsAction" :key="i" dense>
                        <v-list-item
                          @click="Fn_CheckActionType(list.service, item)"
                          link
                        >
                          <v-list-item-icon class="mr-3">
                            <v-icon :color="list.color"
                              >{{ list.icon }}
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            v-if="$t('default') === 'th'"
                            :inner-text.prop="list.text"
                            style="font-size: 14px"
                          ></v-list-item-title>
                          <v-list-item-title
                            v-else
                            :inner-text.prop="list.text2"
                            style="font-size: 14px"
                          ></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
                <v-pagination
                  :total-visible="7"
                  class="pt-2"
                  circle
                  color="#077893"
                  v-model="Page"
                  :length="PageCount"
                  @input="Fn_ChangePage"
                >
                </v-pagination>
              </v-card-text>
              <v-card-actions class="pa-2">
                <v-layout row wrap justify-end align-center>
                  <v-flex xs3 sm3 md2 lg2>
                    <v-btn
                      block
                      dark
                      color="#077893"
                      v-if="SelectNameEmployee.length > 0"
                      @click="Fn_NextPage"
                    >
                      {{ $t("onechat.next") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs11 lg12 pa-1>
                      <!-- <v-radio-group
                        @change="Fn_SelectTypeConsent"
                        v-model="ConsentType"
                        :rules="[(v) => !!v]"
                        row
                      >
                        <v-radio
                          :label="$t('onechat.text6')"
                          color="#077893"
                          value="SentGeneral"
                        >
                        </v-radio>
                        <v-radio
                          :label="$t('onechat.text7')"
                          color="#077893"
                          value="SentGroup"
                        >
                        </v-radio>
                      </v-radio-group> -->
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-start mt-n6>
                    <v-flex xs11 sm11 md6 lg6 pa-4>
                      <v-card outlined>
                        <v-card-title class="pa-2">
                          <v-layout row wrap justify-start align-center>
                            <v-flex xs10 sm10 md6 lg6>
                              <b class="text-left">{{
                                $t("onechat.nameSelect")
                              }}</b>
                            </v-flex>

                            <v-flex xs10 sm10 md6 lg6 class="text-end">
                              <v-chip
                                class="ma-2 white--text"
                                color="#077893"
                                v-if="$t('default') === 'th'"
                              >
                                จำนวนทั้งหมด&nbsp;
                                <b> {{ SelectNameEmployee.length }} </b>
                                &nbsp;คน
                              </v-chip>
                              <v-chip
                                class="ma-2 white--text"
                                color="#077893"
                                v-else
                              >
                                Total&nbsp;
                                <b> {{ SelectNameEmployee.length }} </b>
                                &nbsp;person
                              </v-chip>
                            </v-flex>
                          </v-layout>
                        </v-card-title>
                        <v-card-text style="max-height: 260px; overflow: auto">
                          <!-- {{ SelectNamePosition }} -->
                          <div
                            class="d-flex align-center hover"
                            v-for="(item, i) in SelectNameEmployee"
                            :key="i"
                          >
                            <p
                              class="my-2 pl-3 black--text"
                              v-if="$t('default') === 'th'"
                            >
                              {{ item.NameTh }}
                            </p>
                            <p
                              class="my-2 pl-3 black--text"
                              v-else-if="
                                $t('default') === 'en' && item.NameEng !== ''
                              "
                            >
                              {{ item.NameEng }}
                            </p>
                            <p
                              class="my-2 pl-3 black--text"
                              v-else-if="
                                $t('default') === 'en' && item.NameEng == ''
                              "
                            >
                              {{ item.NameTh }}
                            </p>
                            <v-spacer></v-spacer>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs11 sm11 md6 lg6 pa-3>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("NewUpdate.DetailAnn1") }} </b>
                      <v-select
                        dense
                        :items="ItemPolicy"
                        :label="$t('NewUpdate.DetailAnn1')"
                        :rules="[(v) => !!v]"
                        item-text="Title"
                        v-model="SelectPolicy"
                        item-value="PolicyId"
                        outlined
                      >
                      </v-select>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("NewUpdate.DetailAnn2") }} </b>
                      <v-text-field
                        :rules="[(v) => !!v]"
                        :label="$t('NewUpdate.DetailAnn3')"
                        v-model="GroupSend"
                        outlined
                        dense
                      ></v-text-field>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("NewUpdate.DetailAnn4") }} </b>
                      <v-text-field
                        :rules="[(v) => !!v]"
                        :label="$t('NewUpdate.DetailAnn5')"
                        v-model="AnnounceNo"
                        outlined
                        dense
                      ></v-text-field>
                      <div class="mt-n4 text-right">
                        <b class="red--text">{{
                          $t("NewUpdate.DetailAnn6")
                        }}</b>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-form>
              <v-card-actions class="mt-n5">
                <v-layout
                  row
                  wrap
                  mr-3
                  ml-5
                  :justify-space-between="$vuetify.breakpoint.lgAndUp"
                  align-center
                  :justify-center="$vuetify.breakpoint.smAndDown"
                >
                  <v-flex xs8 sm7 md2 lg2>
                    <v-btn block dark color="#077893" @click="StatusBtn = 1">
                      {{ $t("onechat.back") }}
                    </v-btn>
                  </v-flex>
                  <v-flex xs8 sm7 md2 lg2>
                    <v-btn
                      block
                      dark
                      color="#077893"
                      :loading="LoadingSentConsent"
                      @click="Fn_Save()"
                    >
                      {{ $t("NewUpdate.announ1") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <br />
      </v-card-text>
    </v-card>
    <!-- ประวัติ อีเมล -->
    <!-- <LogEmail /> -->
    <DialogEdit
      :show="DialogEdit"
      :_item="ItemEdit"
      @closeDialogEdit="DialogEdit = false"
      @reData="Fn_ResetData()"
    />
    <DialogDelete
      :show="DialogDelete"
      :_item="ItemDelete"
      @closeDialogDelete="DialogDelete = false"
      @reData="Fn_ResetData()"
    />
    <DialogListImport
      :show="DialogListImport"
      :_detail="DataList"
      @closeDialogDelete="DialogListImport = false"
    />
    <DialogCheckUser
      :show="DialogList"
      :_detail="ItemsCheckUser"
      @closeDialogDelete="DialogList = false"
    />
    <div v-if="loadingDownloadData">
      <OverlaySearch />
    </div>
  </div>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import DialogCheckUser from "@/components/dialog/Announce/OnePlatform/DialogAnnounceCheckUserOnechat.vue";
import DialogListImport from "@/components/dialog/Announce/Onechat/DialogAnnounceListImport.vue";
import DialogDelete from "@/components/dialog/DialogOneAccountDelete.vue";
import DialogEdit from "@/components/dialog/DialogOneAccountEdit.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  components: {
    OverlaySearch,
    DialogEdit,
    DialogDelete,
    DialogCheckUser,
    DialogListImport,
  },
  data: function () {
    return {
      file: [],
      StatusBtn: 1,
      valid: true,
      LoadingUpload: false,
      dragging: false,
      ShowPolicy: false,
      DialogList: false,
      DialogListImport: false,
      LoadingSentConsent: false,
      loadingDownloadData: false,
      loadingDownloadCSV: false,
      DisabledPosition: false,
      ConsentType: "SentGeneral",
      DataImportCsv: [],
      ItemsDepartment: [],
      ItemsRole: [],
      DataList: [],
      ItemsPosition: [],
      ItemPolicy: [],
      ItemConsentGeneral: [],
      ItemConsentGroup: [],
      ItemsListConsent: [],
      SelectNameEmployee: [],
      ItemsCheckUser: [],
      SelectPolicy: "",
      SelectConsentGroup: " ",
      SelectDepartment: "",
      SelectRole: "",
      StatusErr: "",
      TypeSent: "",
      DepartmentId: "",
      AnnounceNo: "",
      GroupSend: "",
      Search: "",
      PathApi: "",
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      ListPerpage: [10, 50, 100],
      interval: 0,
      value: 0,
      Total: 0,
      query: false,
      show: true,
      btnSendLoading: false,
      DialogDelete: false,
      DialogEdit: false,
      showeProgress: false,
      ItemEdit: [],
      ItemDelete: [],
      ItemEmployee: [],
      ItemConsentCount: [],
      PayloadSearch: [],
      itemsAction: [
        {
          icon: "mdi-pencil",
          text: "แก้ไขข้อมูล",
          text2: "Edit",
          color: "orange",
          service: "Edit",
        },
        {
          icon: "mdi-trash-can",
          text: "ลบข้อมูล",
          text2: "Delete",
          color: "red",
          service: "Del",
        },
      ],
    };
  },
  mounted() {
    this.Fn_Search();
  },
  methods: {
    Fn_BackIndex() {
      this.$router.push("/consent-create-onechat");
    },
    Fn_NextPage() {
      if (this._DataGroupOneChatSearch.Consent === undefined) {
        this.StatusBtn = 2;
        this.Fn_SelectTypeConsent();
      } else if (this._DataGroupOneChatSearch.Consent.length > 0) {
        this.Fn_CheckUserOnechat();
      }
    },
    async Fn_CheckUserOnechat() {
      for (var i in this.SelectNameEmployee) {
        delete this.SelectNameEmployee[i].Email;
        delete this.SelectNameEmployee[i].Mobile;
      }
      this.payloadUserOnechat = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        Receiver: this.SelectNameEmployee,
        PolicyId: this._DataGroupOneChatSearch.Policy[0].PolicyId,
        AnnounceName: this._DataAnnounce,
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "onechat/CheckUserAnnounce",
          this.payloadUserOnechat
        )
        .then((response) => {
          this.LoadingSentConsent = false;
          if (response.data.Status === "OK") {
            this.ItemsCheckUser = response.data.Message;
            this.DialogList = true;
            this.$emit("closeDialog");
            this.$store.dispatch("SET_DATA_CHECK_USER", this.ItemsCheckUser);
          } else {
            this.LoadingSentConsent = false;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSentConsent = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_SelectTypeConsent() {
      if (this.ConsentType === "SentGeneral") {
        this.SelectPolicy = "";
        this.SelectConsentGeneral = "";
        this.Fn_GetPolicy();
      } else if (this.ConsentType === "SentGroup") {
        this.SelectConsentGroup = "";
        this.Fn_GetConsentGroup();
      }
    },
    async Fn_GetPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        TimeStamp: this.$cookies.get("Timestamps"),
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        TimeStamp: this.$cookies.get("Timestamps"),
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Save() {
      if (this.$refs.form.validate()) {
        this.LoadingSentConsent = true;
        for (var i in this.SelectNameEmployee) {
          delete this.SelectNameEmployee[i].BusinessId;
          delete this.SelectNameEmployee[i].UpdatdeAt;
          delete this.SelectNameEmployee[i].UpdatdeAtEng;
        }

        if (this._DataGroupOneChatSearch.Consent === undefined) {
          this.PathApi = "onechat//OnePlatform/SendAnnounce";
          this.$store.dispatch("SET_DATA_GROUP_ONECHAT", []);

          this.payloadUserOnechat = {
            BusinessId: this.$cookies.get("BusinessId"),
            Receiver: this.SelectNameEmployee,
            PolicyId: this.SelectPolicy,
            UserId: this.$cookies.get("OneAccountId"),
            AnnounceName: this.GroupSend,
            AnnounceNo: this.AnnounceNo,
            AccessToken: this.$cookies.get("OneAccessToken"),
          };
        } else if (this._DataGroupOneChatSearch.Consent.length > 0) {
          this.PathApi = "onechat/OnePlatform/SendAnnounceAddOn";
          this.SelectPolicy = this._DataGroupOneChatSearch.Policy[0].PolicyId;

          this.payloadUserOnechat = {
            BusinessId: this.$cookies.get("BusinessId"),
            Receiver: this.SelectNameEmployee,
            PolicyId: this.SelectPolicy,
            UserId: this.$cookies.get("OneAccountId"),
            AnnounceName: this.GroupSend,
            AccessToken: this.$cookies.get("OneAccessToken"),
            TransactionId: this._DataGroupOneChatSearch,
          };
        }

        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + this.PathApi,
            this.payloadUserOnechat
          )
          .then((response) => {
            this.LoadingSentConsent = false;
            if (response.data.Status === "OK") {
              this.Items = response.data.Message;
              Toast.fire({
                icon: "success",
                title: this.$t("NewUpdate.announ4"),
              });
              setTimeout(() => {
                window.location.reload();
              }, 1500);
            } else {
              this.LoadingSentConsent = false;
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.LoadingSentConsent = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    fn_setResendDefault() {
      this.showeProgress = true;
      this.show = true;
      this.query = true;
      this.value = 0;
      setTimeout(() => {
        this.query = false;
        this.interval = setInterval(() => {
          if (this.value === 90) {
            clearInterval(this.interval);
          }
          this.value += 10;
        }, 1000);
      }, 2500);
    },
    Fn_SubmitFile() {
      this.LoadingUpload = true;
      this.fn_setResendDefault();
      var formData = new FormData();
      formData.append("File", this.file);
      formData.append("AccountId", this.$cookies.get("OneAccountId"));
      formData.append("BusinessId", this.$cookies.get("BusinessId"));
      formData.append("AccessToken", this.$cookies.get("OneAccessToken"));

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/Import",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.value = 0;
            this.show = false;
            this.showeProgress = false;
            this.LoadingUpload = false;
            this.DialogListImport = true;
            this.DataList = response.data.Data;
            this.DataImportCsv = response.data.Data.Success;
            this.StatusErr = response.data.Status;
            Toast.fire({
              icon: "success",
              title:
                this.$i18n.t("alert.upload") +
                " " +
                this.file.name +
                " " +
                this.$i18n.t("alert.success"),
            });
            this.Fn_ResetData();
          } else {
            this.LoadingUpload = false;
            this.StatusErr = response.data.ErrorMessage;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.value = 0;
          this.show = false;
          this.showeProgress = false;
          this.filesUpload = [];
          this.LoadingUpload = false;
          this.StatusErr = error.response.data.ErrorMessage;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_OnChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.Fn_CreateFile(files[0]);
    },
    Fn_CreateFile(file) {
      this.loadingDownloadData = true;
      if (
        !file.type.match(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        Toast.fire({
          icon: "error",
          title: this.$i18n.t("oneAccount.excel"),
        });
        this.dragging = false;
        this.loadingDownloadData = false;
      } else if (file.size > 5000000) {
        Toast.fire({
          icon: "error",
          title: this.$i18n.t("oneAccount.check"),
        });
        this.dragging = false;
        this.loadingDownloadData = false;
      } else if (this.file !== null) {
        this.file = file;
        this.dragging = false;
        this.loadingDownloadData = false;
      }
    },
    Fn_RemoveFile() {
      this.file = [];
      Toast.fire({
        icon: "success",
        title: this.$i18n.t("alert.del") + " " + this.$i18n.t("alert.success"),
      });
    },
    Fn_CheckActionType(val, item) {
      if (val === "Edit") {
        this.Fn_Update(item);
      } else if (val === "Del") {
        this.Fn_Delete(item);
      }
    },
    async Fn_Search() {
      this.loadingDownloadData = true;
      this.btnSendLoading = true;
      this.PayloadSearch = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        PerPage: this.ItemPerPage,
        Page: this.Page,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/GetOneAccount",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          this.btnSendLoading = false;
          if (response.data.Status === "OK") {
            this.ItemEmployee = response.data.Message.Detail;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;
            this.ItemPerPage = response.data.Message.PageDetail.PerPage;
            this.Total = response.data.Message.PageDetail.Total;
            var CountPage = response.data.Message.PageDetail.From;

            var startPage = CountPage;
            var nextPage = startPage + this.ItemEmployee.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemEmployee) {
              this.ItemEmployee[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          this.btnSendLoading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_ResetData() {
      this.file = [];
      this.loadingDownloadData = true;
      this.PayloadSearch = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        PerPage: this.ItemPerPage,
        Page: this.Page,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/GetOneAccount",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemEmployee = response.data.Message.Detail;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;
            // this.ItemPerPage = response.data.Message.PageDetail.PerPage
            this.Total = response.data.Message.PageDetail.Total;

            var CountPage = response.data.Message.PageDetail.From;
            var startPage = CountPage;
            var nextPage = startPage + this.ItemEmployee.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemEmployee) {
              this.ItemEmployee[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_ChangePage() {
      this.loadingDownloadData = true;
      this.btnSendLoading = true;
      this.PayloadSearch.Page = this.Page++;
      this.PayloadSearch.PerPage = this.ItemPerPage;
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/GetOneAccount",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          this.btnSendLoading = false;
          if (response.data.Status === "OK") {
            this.ItemEmployee = response.data.Message.Detail;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;

            this.Total = response.data.Message.PageDetail.Total;
            var CountPage = response.data.Message.PageDetail.From;

            var startPage = CountPage;
            var nextPage = startPage + this.ItemEmployee.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemEmployee) {
              this.ItemEmployee[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          this.btnSendLoading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_SelectPerPage() {
      this.Page = 1;
      this.loadingDownloadData = true;
      this.btnSendLoading = true;
      this.PayloadSearch.Page = this.Page++;
      this.PayloadSearch.PerPage = this.ItemPerPage;
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/GetOneAccount",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          this.btnSendLoading = false;
          if (response.data.Status === "OK") {
            this.ItemEmployee = response.data.Message.Detail;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;

            var CountPage = response.data.Message.PageDetail.From;
            this.Total = response.data.Message.PageDetail.Total;

            var startPage = CountPage;
            var nextPage = startPage + this.ItemEmployee.length;

            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemEmployee) {
              this.ItemEmployee[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          this.btnSendLoading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Update(item) {
      this.DialogEdit = true;
      this.ItemEdit = item;
    },
    Fn_Delete(item) {
      this.DialogDelete = true;
      this.ItemDelete = item;
    },
  },
  computed: {
    ...mapGetters(["DataAnnounce"]),
    ...mapGetters(["StatusBusiness"]),
    ...mapGetters(["DataGroupOneChatSearch"]),
    AccountId: {
      get() {
        return this.$cookies.get("OneAccountId") || "-";
      },
    },
    _DataGroupOneChatSearch: {
      get() {
        return this.DataGroupOneChatSearch || "-";
      },
    },
    _DataAnnounce: {
      get() {
        return this.DataAnnounce || "-";
      },
    },
    extension() {
      return this.file ? this.file.name.split(".").pop() : "";
    },
    headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          align: "center",
          value: "no",
          sortable: false,
        },
        {
          text: "One Account ID",
          align: "left",
          value: "AccountId",
          sortable: false,
        },
        {
          text: this.$i18n.t("NewUpdate.Name"),
          value: "NameTh",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.cby"),
          value: "NameTh_Manage",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("onechat.date"),
          value: "UpdatdeAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.choice"),
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    $route(to) {
      document.title = `APPLICATION_NAME - ${to.meta.title}`;
      const link = document.querySelector("[rel='icon']");
      link.setAttribute("href", to.meta.icon);
    },
    TypeSent(val) {
      if (val === "SentAll") {
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = true;
      } else {
        this.ItemsPosition = [];
      }
    },
    SelectDepartment(val) {
      if (val.DepartmentId === "00000") {
        this.DepartmentId = "00000";
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = true;
      } else if (val.Role.length >= 1) {
        this.ItemsRole = val.Role;
        this.DisabledPosition = false;
      } else {
        this.DepartmentId = "00000";
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = true;
      }
    },
    SelectRole(val) {
      this.ItemsPosition = val.Account;
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.dropZone {
  width: 100%;
  height: 138px;
  position: relative;
  border: 2px dashed #eee;
  transition: 0.3s;
  border-radius: 0.5rem;
}

.dropZone:hover {
  border: 2px dashed #077893;
  opacity: 1;
  border-radius: 0.5rem;
  background-color: #00000021;
}

.dropZone:hover,
.dropZone-title:hover {
  color: #077893;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.hover:hover {
  background-color: #ddf7ff;
}
</style>
